import {AfterViewInit, Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {OrdSpedEsolver} from '../../../_models/OrdSpedEsolver';
import {Subscription} from 'rxjs';
import {SaveMessage} from '../../../_helpers/save-message';
import {LocalService} from '../../../_services/local.service';
import {OrganizzazioniService} from '../../../_services/organizzazioni.service';
import {OrdinispedizioniService} from '../../../_services/ordinispedizioni.service';
import {SearchResult} from '../../../_models/SearchResult';
import {Organizzazione} from '../../../_models/Organizzazione';
import {HubMonitorService} from '../../../_services/hub-monitor.service';
import {skip} from 'rxjs/operators';

@Component({
    selector: 'app-spedizioni-esolver-list',
    templateUrl: './spedizioni-esolver-list.component.html',
    styleUrls: ['./spedizioni-esolver-list.component.scss'],
    standalone: false
})
export class SpedizioniEsolverListComponent  implements OnInit, OnDestroy, AfterViewInit {
  spedizioniEsolver: OrdSpedEsolver[] = [];
  sortDirection = true;
  sortKey = 'dataSpedizione';
  loading = false;
  page = 0;
  count = 50;
  totalCount = 0;
  loadMore = false;
  selStato = 1;
  numReg = -1;
  codArt = '';
  cliente = '';
  subscription: Subscription;
  private autoLoadObserver: IntersectionObserver | null = null;
  private autoLoadTriggerElement: HTMLElement | null = null;

  @ViewChild('autoLoadTrigger')
  set autoLoadTrigger(ref: ElementRef<HTMLElement> | undefined) {
    this.autoLoadTriggerElement = ref?.nativeElement ?? null;
    void this.observeAutoLoadTrigger();
  }

  constructor(
    private saveMessage: SaveMessage,
    private localService: LocalService,
    private organizzazioneService: OrganizzazioniService,
    private spedizioniService: OrdinispedizioniService,
    private hubMonitorService: HubMonitorService,
    private hostElement: ElementRef<HTMLElement>,
    private ngZone: NgZone) { }

  ngOnInit() {
    this.subscription = this.localService.searchText.subscribe((_value: string) => {
      this.getSpedizioniEsolver(_value, false);
    });
    this.subscription.add(this.organizzazioneService.currentOrganizzazioneSubject.pipe(skip(1)).subscribe((_org: Organizzazione) => {
      this.getSpedizioniEsolver('',false);
    }));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.autoLoadObserver?.disconnect();
  }

  ngAfterViewInit(): void {
    void this.observeAutoLoadTrigger();
  }

  getSpedizioniEsolver = (search: string, add: boolean) => {
    this.loading = true;
    this.loadMore = true;
    if (!add) {
      this.page = 0;
    } else {
      this.page += 1;
    }
    return  this.spedizioniService
      .getSpedizioniEsolver(this.organizzazioneService.organizzazioneId,
        this.organizzazioneService.currentOrganizzazioneValue.codiceGruppo,
        this.organizzazioneService.currentOrganizzazioneValue.codice,
        search, this.page, this.count, this.sortKey, this.sortDirection, this.selStato, false, [], false,
        this.numReg, this.codArt, this.cliente)
      .then((_spedizioniEsolver: SearchResult<OrdSpedEsolver>) => {
        this.totalCount = _spedizioniEsolver.totalCount;
        if (_spedizioniEsolver.totalCount === 0) {
          this.spedizioniEsolver = [];
          this.loadMore = false;
          return false;
        }
        if (!add) {
          this.spedizioniEsolver = _spedizioniEsolver.result;
        } else {
          _spedizioniEsolver.result.forEach((spe: OrdSpedEsolver) => this.spedizioniEsolver.push(spe));
        }
        if (_spedizioniEsolver.totalCount <= this.spedizioniEsolver.length) {
          this.loadMore = false;
        }
      })
      .catch((_err) => this.saveMessage.messageError("Ci sono problemi con il caricamento degli eventi."))
      .finally(() => {
        this.loading = false;
        void this.observeAutoLoadTrigger();
      });
  };

  openHubMonitor(event?: Event) {
    event?.preventDefault();
    event?.stopPropagation();
    this.hubMonitorService.requestOpenHubMonitor();
  }

  private async observeAutoLoadTrigger(): Promise<void> {
    this.autoLoadObserver?.disconnect();
    if (!this.autoLoadTriggerElement || !this.loadMore) {
      return;
    }

    const ionContent = this.hostElement.nativeElement.closest('ion-content') as HTMLIonContentElement | null;
    const root = ionContent ? await ionContent.getScrollElement().catch(() => null) : null;

    this.autoLoadObserver = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) {
        return;
      }

      this.ngZone.run(() => {
        if (this.loadMore && !this.loading) {
          void this.getSpedizioniEsolver('', true);
        }
      });
    }, {
      root,
      rootMargin: '0px 0px 320px 0px'
    });

    this.autoLoadObserver.observe(this.autoLoadTriggerElement);
  }
}
